import { FilterAdapter, useUrlFilterController } from 'app/components/filters/url-filters';
import { StatisticsFiltersStyles } from 'app/components/common/common-styles';
import Select from 'react-select';
import { SubjectType, SubjectTypeLabels } from 'app/console-api/statistics/types';

export const EventOriginFilterAdapter: FilterAdapter<string> = {
  key: 'subjectType',
  fromUrl: (sp) => {
    const raw = sp.get('subjectType');
    if (!raw) return null;
    return raw;
  },
  toUrl: (sp, value) => {
    const next = new URLSearchParams(sp.toString());
    if (!value) {
      next.delete('subjectType');
    } else {
      next.set('subjectType', value);
    }
    return next;
  },
  toKey: (v) => `subjectType:${v || 'none'}`
};

type EventOriginFilterProps = {
  placeholder?: string;
} & Record<string, any>;

export function EventOriginFilter({
  placeholder = 'All event`s origins',
  props
}: EventOriginFilterProps) {
  const ctl = useUrlFilterController();
  const value = ctl.get(EventOriginFilterAdapter);

  const options = [
    { value: SubjectType.Offer, label: SubjectTypeLabels[SubjectType.Offer] },
    { value: SubjectType.Task, label: SubjectTypeLabels[SubjectType.Task] }
  ];

  const selected = options.find((o) => o.value === value) ?? null;

  return (
    <Select
      styles={StatisticsFiltersStyles()}
      {...props}
      isClearable
      isSearchable={false}
      options={options}
      value={selected}
      placeholder={placeholder}
      onChange={(opt: any) => ctl.set(EventOriginFilterAdapter, opt?.value ?? null)}
    />
  );
}
